var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "modal fade",
      staticStyle: { overflow: "hidden", "z-index": "2000" },
      attrs: { id: _vm.modalId, "data-backdrop": "static" }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-scrollable modal-xs",
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("txtActivityReference")) +
                  "\n                "
              ),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-toggle": "modal",
                    "data-target": "#" + _vm.modalId
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.close.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.reference,
                    expression: "reference"
                  }
                ],
                staticClass: "form-control",
                domProps: { value: _vm.reference },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.reference = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button" },
                  on: { click: _vm.save }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("btnSave")) +
                      "\n                "
                  )
                ]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }